export default __webpack_public_path__ + "static/media/MBWAY.53ae84ec.svg";